import type { AdminOrganizationMember } from "./types";

export type MemberAction = "changeRole" | "manageLocations" | "reactivate";

export interface MemberPermissions {
  /** `org.admins.manage`: change roles, and reactivate an ADMIN. */
  readonly manageAdmins: boolean;
  /** `org.members.manage`: manage a STAFF's locations, and reactivate a STAFF. */
  readonly manageMembers: boolean;
}

/**
 * The actions the viewer may start on one roster row. This mirrors the API's
 * checks so the BO does not offer what would answer 403: the owner never has
 * any, only ACTIVE ADMIN/STAFF change role, only an ACTIVE STAFF has locations,
 * and reactivating needs the permission of the TARGET's role.
 */
export function availableMemberActions(
  member: AdminOrganizationMember,
  permissions: MemberPermissions,
): readonly MemberAction[] {
  if (member.role === "OWNER") return [];
  const actions: MemberAction[] = [];
  if (member.status === "ACTIVE") {
    if (permissions.manageAdmins) actions.push("changeRole");
    if (member.role === "STAFF" && permissions.manageMembers) actions.push("manageLocations");
  } else {
    const allowed = member.role === "ADMIN" ? permissions.manageAdmins : permissions.manageMembers;
    if (allowed) actions.push("reactivate");
  }
  return actions;
}
